<div width="50">
    <div (click)="onClickExpand()" class="expander-btn">
        <fa-icon [icon]="rotation ? faAngleDown : faAngleRight"></fa-icon>
    </div>
</div>
<!-- <div>
    <div
    [style.transform]="rotation"
    (click)="onClickExpand()"
    class="expander-btn"
    >
        &gt;
    </div>
    <button (click)="onClickEdit()">Edit</button>
</div> -->
